export type StringInputFieldType = 'text' | 'email' | 'password' | 'number';
export type TagsInputFieldType = 'text' | 'email';
